//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { MyTasksConfig } from './MyTasksConfig';
import { TaskOrder, TaskFilter, TaskGroupOrder, TaskGroupFilter } from '../Shared/Tasks/TaskModels';
import { IFilterDefinitionModel } from '../Shared/Models/FilteringModel';
import { ReportModel, SystemType } from '../Reports/ReportsModels';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';
import { Translations } from '../Shared/Models/StaticTranslations';

export class MyTasksRecordList {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private treeView: any;
    private treeData: Array<INode> = [];
    private issueMaxNumberInList: number = 10;
    private issueCountFromServer_Individual: number = 0;
    private issueCountFromServer_Group: number = 0;
    private issueCountFromServer_Pool: number = 0;
    private currentPage: number = 0;
    private pinListFormEl = $('#myTasksRecordListPinBtn');
    private currentSortOrder;
    private currentSortDirection: OrderDirection;

    // List of buttions in the action toolbar
    private actionBtns = {
        viewprint: { btn: $('#myTasksRecordListPrintBtn'), enable: false },
        showmap: { btn: $('#myTasksRecordListShowMapBtn'), enable: false }
    };

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // Enabled TaskGroups 
        if (MyTasksConfig.TaskGroupEnabled == false) {
            $('#myTasksRecordListOptionGroupTasksContainer').hide();
        }

        // Bind buttons
        $('#myTasksRecordListCloseBtn').on("click", function () {
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventResetAllButtons(true));
        });

        // Add pin btn event
        self.pinListFormEl.on("click", function () { Utilities.TogglePinListForm($(this)); });

        $('#myTasksRecordListOptionIndividualTasks').on('change', function () { changeRadioCss($($(this)));  if ($(this).is(':checked')) self.showIndividualTasks(); });
        $('#myTasksRecordListOptionGroupTasks').on('change', function () { changeRadioCss($($(this))); if ($(this).is(':checked')) self.showGroupTasks(); });
        $('#myTasksRecordListOptionPoolTasks').on('change', function () { changeRadioCss($($(this))); if ($(this).is(':checked')) self.showPoolTasks(); });

        function changeRadioCss(el: JQuery<HTMLElement>) {
            // Set css
            $("#myTasksRecordListOptionIndividualTasks").parent().removeClass('active');
            $("#myTasksRecordListOptionGroupTasks").parent().removeClass('active');
            $("#myTasksRecordListOptionPoolTasks").parent().removeClass('active');
            el.parent().addClass('active');
        }

        $('#myTasksRecordFilter').on('change', function () { self.recordFilterSelected(); });
        $('#myTasksRecordListPageAmount select').on('change', function () { self.myTasksRecordListPageAmountSelected(); });
        $('#myTasksRecordListSelectAllBtn').on('change', function () { self.myTasksRecordListSelectAllChecked(); });
        $('#myTasksRecordListSearchBtn').on('click', function () {  self.GetTreeData(); this.blur(); });
        $('#myTasksRecordListShowCustomFilterBtn').on("click", function () { toastr.info("To be completed"); this.blur(); });

        // Action buttons
        self.actionBtns.showmap.btn.on('click', function () { self.ZoomToChecked(); this.blur();  });
        self.actionBtns.viewprint.btn.on('click', function () {
            // Setup variables
            let data: ReportModel = {};
            var values: Array<string> = [];
            let filterDef: IFilterDefinitionModel = $('#myTasksRecordFilter').children("option:selected").data('filterdefinition');

            // Get seleced nodes
            var nodes: Array<INode> = self.treeView.treeview('getSelected');
            if (nodes != null) {
                nodes = nodes.concat(self.treeView.treeview('getChecked')); // This makes sure we get all selected and checked nodes
                nodes.forEach(n => values.push(n.href));
            }

            // Get feature type
            if (nodes.length == 1) { data.systemType = SystemType.MyTasks_Task_Single; }
            else { data.systemType = SystemType.MyTasks_Task_Multi; }
           
            // If there is NO filterDef.viewName, then do not prompt the user 
            if (filterDef == null || filterDef.viewName == null) {
                var selectedMsg = "Selected Records Only (" + values.length + ")";
                data.reportParameters = [{ name: "codes", values: values }];
                events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
            }
            else {
                var filterMsg = "Filter (" + filterDef.label + ")";
                var selectedMsg = "Selected Records Only (" + values.length + ")";

                var dataStr = [{ key: "AllLabel", value: filterDef.label }, { key: "FilterLabel", value: values.length }, { key: "YesBtn", value: values.length }, { key: "NoBtn", value: filterDef.label }];
                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.RecordListReport, data: dataStr }).then(r => {
                    if (r.yes == true) {
                        data.reportParameters = [{ name: "codes", values: values }];
                        events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
                    }
                    else {
                        data.reportParameters = [{ name: "filterViewName", values: [filterDef.viewName] }];
                        events.bus.publish(events.eventOpenReportOrSelectList([data, filterMsg]));
                    }
                }).catch(e => { });
            }
        });

        $('#myTasksRecordListShowingStartBtn').on("click", function () {
            self.currentPage = 0;
            this.blur(); 
            self.GetTreeData();
        });
        $('#myTasksRecordListShowingEndBtn').on("click", function () {
            if ($('#myTasksRecordListOptionIndividualTasks').is(':checked')) {
                self.currentPage = Math.trunc(self.issueCountFromServer_Individual / self.issueMaxNumberInList);
            }
            if ($('#myTasksRecordListOptionGroupTasks').is(':checked')) {
                self.currentPage = Math.trunc(self.issueCountFromServer_Group / self.issueMaxNumberInList);
            }
            if ($('#myTasksRecordListOptionPoolTasks').is(':checked')) {
                self.currentPage = Math.trunc(self.issueCountFromServer_Pool / self.issueMaxNumberInList);
            }
            this.blur(); 
            self.GetTreeData();
        });
        $('#myTasksRecordListShowingNextBtn').on("click", function () {
            if ($('#myTasksRecordListOptionIndividualTasks').is(':checked')) {
                if (self.currentPage == Math.trunc(self.issueCountFromServer_Individual / self.issueMaxNumberInList)) return;
            }
            if ($('#myTasksRecordListOptionGroupTasks').is(':checked')) {
                if (self.currentPage == Math.trunc(self.issueCountFromServer_Group / self.issueMaxNumberInList)) return;
            }
            if ($('#myTasksRecordListOptionPoolTasks').is(':checked')) {
                if (self.currentPage == Math.trunc(self.issueCountFromServer_Pool / self.issueMaxNumberInList)) return;
            }
            self.currentPage++;
            this.blur(); 
            self.GetTreeData();
        });
        $('#myTasksRecordListShowingPrevBtn').on("click", function () {
            if (self.currentPage == 0) return;
            self.currentPage--;
            this.blur(); 
            self.GetTreeData();
        });

    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public OpenMyTasksRecordListPanel = (): void => {
        // Reset the page and focus the individual tasks btn
        this.resetPage();

        $('#myTasksRecordListPanel').addClass('show');
        $('#myTasksRecordListFilterContainer').hide();

        // turn off all the buttons to start with 
        this.checkFilters(true);
        this.checkVisibleButtons();

        // Set initial selection
        $('#myTasksRecordListOptionIndividualTasks').focus();
        $('#myTasksRecordListOptionIndividualTasks').prop('checked', true);
        this.recordFilterSelected();

        // Get the initial task count
        this.getInitialTasksCount();
    }

    // ----------------------------------------------------------- //
    // SWITCH MODES
    private showIndividualTasks = (): void => {
        this.resetPage();
        this.checkFilters();
        this.checkVisibleButtons();
        this.recordFilterSelected();
    }

    private showGroupTasks = (): void => {
        this.resetPage();
        this.checkFilters();
        this.checkVisibleButtons();
        this.recordFilterSelected();
    }

    private showPoolTasks = (): void => {
        this.resetPage();
        this.checkFilters();
        this.checkVisibleButtons();
        this.GetTreeData();
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetTreeData = (): void => {
        const self = this;

        // Depending on what button is checked, get different data
        let url, query, viewName = "";
        let filterDef: IFilterDefinitionModel = $('#myTasksRecordFilter').children("option:selected").data('filterdefinition');
        if (filterDef != null) {
            viewName = filterDef.viewName;
        }
        else {
            console.log("MyTasks GetTreeData: No filter/view seledted.");
            return;
        }

        if ($('#myTasksRecordListOptionIndividualTasks').is(':checked')) {
            url = window.G_SITEFOLDERNAME+"/MyTasks/GetMyTasksTreeData";
            query = { data: { viewName: viewName, Order: self.currentSortOrder, OrderDirection: self.currentSortDirection, Skip: self.currentPage * self.issueMaxNumberInList, Take: self.issueMaxNumberInList } };
            getData();
        }

        if ($('#myTasksRecordListOptionGroupTasks').is(':checked')) {
            url = window.G_SITEFOLDERNAME + "/MyTasks/GetTaskGroupsTreeData";
            query = { data: { viewName: viewName, Order: self.currentSortOrder, OrderDirection: self.currentSortDirection, Skip: self.currentPage * self.issueMaxNumberInList, Take: self.issueMaxNumberInList } };
            getData();
        }

        if ($('#myTasksRecordListOptionPoolTasks').is(':checked')) {
            url = window.G_SITEFOLDERNAME + "/MyTasks/GetTasksInPool";
            query = { data: { viewName: viewName, Order: self.currentSortOrder, OrderDirection: self.currentSortDirection, Skip: self.currentPage * self.issueMaxNumberInList, Take: self.issueMaxNumberInList } };
            getData();
        }
       
        function getData() {
            Utilities.BlockUI($('#myTasksRecordListPanel'));
            $.post(url, query,
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            self.DeleteAllNodes();
                  
                            // Create tree
                            var data = result.data.nodes as Array<INode>;
                            self.createTreeData(data);
                            self.createTree(self.treeData, true);

                            if ($('#myTasksRecordListOptionIndividualTasks').is(':checked')) {
                                self.issueCountFromServer_Individual = result.data.total;
                                $('#myTasksRecordCountIndividual').html(' (' + self.issueCountFromServer_Individual + ')');
                            }
                            else if ($('#myTasksRecordListOptionGroupTasks').is(':checked')) {
                                self.issueCountFromServer_Group = result.data.total;
                                $('#myTasksRecordCountGroup').html(' (' + self.issueCountFromServer_Group + ')');
                            }
                            else if ($('#myTasksRecordListOptionPoolTasks').is(':checked')) {
                                self.issueCountFromServer_Pool = result.data.total;
                                $('#myTasksRecordCountPool').html(' (' + self.issueCountFromServer_Pool + ')');
                            }

                            // Reset button
                            self.checkVisibleButtons();

                            // Update UI
                            self.updatePagingUI();
                        }
                        else {
                            toastr.error('Failed to get data!')
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                    finally {
                        Utilities.UnBlockUI($('#myTasksRecordListPanel'));
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    private getInitialTasksCount = (): void => {
        const self = this;
   
        let groupFilters: Array<IFilterDefinitionModel> = $('#myTasksRecordListContainer [data-mytaskgroupsfilters]').data('mytaskgroupsfilters');
        if (groupFilters != null && groupFilters.length != 0) {
            $.get("/MyTasks/GetTaskGroupsCount/"+groupFilters[0].viewName,
                function (result: IAPIResult) {
                    try {
                        self.issueCountFromServer_Group = result as number;
                        $('#myTasksRecordCountGroup').html(' (' + self.issueCountFromServer_Group + ')');
                    }
                    catch (err) { console.log(err); }
                }
            );
        }

        let poolFilters: Array<IFilterDefinitionModel> = $('#myTasksRecordListContainer [data-mytaskpoolsfilters]').data('mytaskpoolsfilters');
        if (poolFilters != null && poolFilters.length != 0) {
            $.get("/MyTasks/GetTaskPoolsCount/"+poolFilters[0].viewName,
                function (result: IAPIResult) {
                    try {
                        self.issueCountFromServer_Pool = result as number;
                        $('#myTasksRecordCountPool').html(' (' + self.issueCountFromServer_Pool + ')');
                    }
                    catch (err) { console.log(err); }
                }
            );
        }
    }

    // ----------------------------------------------------------- //
    // ON SELECT CHANGE
    private recordFilterSelected = (): void => {
        // Reset the page
        this.resetPage();

        this.GetTreeData();
    }

    private myTasksRecordListPageAmountSelected = (): void => {
        this.issueMaxNumberInList = $('#myTasksRecordListPageAmount select').children("option:selected").val() as number; 
        this.GetTreeData();
    }

    private myTasksRecordListSelectAllChecked = (): void => {
        const self = this;
        if ($('#myTasksRecordListSelectAllBtn').is(":checked") == true) {
            self.treeView.treeview('checkAll', { silent: true });
        }
        else {
            self.treeView.treeview('uncheckAll', { silent: true });
        }
        self.checkVisibleButtons();
    }

    public TaskUpdatedEvent = (camsKey: ICAMSKey): void => {
        // This fires when the task has been updated (e.g. accepted, etc). So refresh the tree
        this.GetTreeData();
    }

    // ----------------------------------------------------------- //
    // CREATE/ADD TREE
    private createTree = (data: Array<INode>, colapseAll: boolean): void => {
        const self = this;

        var tree: any = $('#myTasksRecordListTreeResults');
        self.treeView = tree.treeview({
            data: data,
            showCheckbox: true,
            multiSelect: false,
            highlightSelected: true,
            onNodeSelected: function (event, node: INode) {
                var isConditionSurvey = null;
                if (node && node.data) isConditionSurvey = node.data.IsConditionSurvey;
                let data: ICAMSKey = {
                    code: node.href,
                    featureType: node.featureType,
                    parentCode: node.parentCode,
                    parentFeatureType: node.parentFeatureType,
                    wkt: node.wkt
                };

                // Otherwise, open it as a task view
                var showclass = "show600";
                if (Utilities.IsListFormPinned(self.pinListFormEl) == false) {
                    showclass = "show";
                    $('#myTasksRecordListPanel').removeClass('show');
                    $('#featureDetailsPanel').removeClass('show600');
                    var closeCallback = function () { $('#myTasksRecordListPanel').addClass('show'); }
                }

                if (node.featureType == FeatureType.TaskGroup) {
                    events.bus.publish(events.eventOpenTaskGroupViewPanel([data, showclass, closeCallback]));
                } else {
                    events.bus.publish(events.eventOpenTasksViewPanel([data, showclass, closeCallback, isConditionSurvey]));
                }
                self.treeView.treeview('uncheckAll', [{ silent: true }]);
                self.checkVisibleButtons(node);
                self.updateNumberCheckedMessage(); 
            },
            onNodeUnselected: function (event, node) {
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage(); 
            },
            onNodeChecked: function (event, node) {
                // Check if any TaskGroup nodes are selected. If they are de-select them and vice versa
                self.treeView.treeview('getChecked').forEach(n => {
                    if (node.featureType == FeatureType.TaskGroup && n.featureType != FeatureType.TaskGroup) {
                        self.treeView.treeview('unselectNode', n, { silent: true });
                    }
                    else if (node.featureType != FeatureType.TaskGroup && n.featureType == FeatureType.TaskGroup) {
                        self.treeView.treeview('unselectNode', n, { silent: true });
                    }
                });

                self.treeView.treeview('unselectAll', [{ silent: true }]);
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage(); 
            },
            onNodeUnchecked: function (event, node) {
                //if (node.nodes != null) {
                //    let nodeIds = []; node.nodes.forEach(n => nodeIds.push(n.nodeId));
                //    self.treeView.treeview('uncheckNode', [nodeIds, { silent: false }]);
                //}
                //  Check button logic
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage(); 
            },
            onMapBtnClicked: function (event, node) {
                if (node.wkt) {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[node.wkt], true, true, node.featureType]));
                }
                else {
                    toastr.info('The record has no associated map feature')
                }
            }
        });

        // Create header
        self.createTreeHeader();

        if (colapseAll == true) {
            self.treeView.treeview('collapseAll');
        }

        self.updateNumberCheckedMessage(); 
    }

    private createTreeData = (input: Array<INode>): void => {
        const self = this;
        
        var inNode = input.find(f => f.featureType == FeatureType.TaskParent);
        if (inNode != null && inNode.nodes != null) {
            inNode.nodes.forEach(i => {
                self.treeData.push(i);
            });
        }

        count(FeatureType.TaskParent);

        function count(featureType: FeatureType) {
            let outNode = self.treeData.find(f => f.featureType == featureType);
            if (outNode != null) {
                if (outNode.nodes == null) {
                    outNode.count = 0;
                }
                else {
                    outNode.count = outNode.nodes.length;
                }
            }
        }
    }

    private DeleteAllNodes = (): void => {
        this.treeData = [];
        this.createTree(this.treeData, true);
    }

    private ZoomToChecked = (): void => {
        const self = this;

        var findCheckableNodes = function () {
            return self.treeView.treeview('getChecked');
        };
        var checkableNodes: Array<INode> = findCheckableNodes();

        var wktArr = []; var hrefArr = []; 
        checkableNodes.forEach(n => {
            // Check if this is a group node, if it is, add all the wKT's below it
            if (n.featureType == FeatureType.TaskGroup && n.nodes != null) {
                n.nodes.forEach(i => { if (i.wkt != null && hrefArr.find(i => i.href == n.href) == null) { wktArr.push(i.wkt); hrefArr.push(i.href); }});
            }
            // If this this is not a group node, then just add it as normal. Check first to see if it is already added though
            if (n.wkt != null && hrefArr.find(i => i.href == n.href) == null) { wktArr.push(n.wkt); hrefArr.push(n.href);  };
        });
        events.bus.publish(events.eventZoomToWKTandHighlight([wktArr, true, true, null]));
    }

    // ----------------------------------------------------------- //
    // TREE HEADERS
    private createTreeHeader = (): void => {
        const self = this;

        var lang = window.isSiteInWelsh() == true ? 1 : 0;

        // Add the header to issues only
        var colDef;
        if ($('#myTasksRecordListOptionIndividualTasks').is(':checked')) {
            colDef = [
                { label: Translations.Lang.RelatesTo[lang], value: TaskOrder.Type, size: 4 },
                { label: Translations.Lang.Type[lang], value: TaskOrder.Type, size: 1 },
                { label: Translations.Lang.Created[lang], value: TaskOrder.CreateDate, size: 2 },
                { label: Translations.Lang.Priority[lang], value: TaskOrder.Priority, size: 2 },
                { label: Translations.Lang.Location[lang], value: TaskOrder.None, size: 3 }
            ];

        }
        else if ($('#myTasksRecordListOptionGroupTasks').is(':checked')) {
            colDef = [
                { label: Translations.Lang.ID[lang], value: TaskGroupOrder.ID, size: 2 },
                { label: Translations.Lang.Priority[lang], value: TaskGroupOrder.Priority, size: 4 },
                { label: Translations.Lang.Status[lang], value: TaskGroupOrder.Status, size: 6 }
            ];
        }
        else if ($('#myTasksRecordListOptionPoolTasks').is(':checked')) {
            colDef = [
                { label: Translations.Lang.ID[lang], value: TaskOrder.ID, size: 2 },
                { label: Translations.Lang.Type[lang], value: TaskOrder.Type, size: 5 },
                { label: Translations.Lang.Priority[lang], value: TaskOrder.Priority, size: 2 },
                { label: Translations.Lang.Status[lang], value: TaskOrder.Status, size: 4 }
            ];
        }

        // Create the header
        self.treeView.treeview('addHeader', {
            cols: colDef,
            currentSortDirection: self.currentSortDirection,
            currentSortOrder: self.currentSortOrder,
            callback: function (order, dir) {
                self.currentSortOrder = order;
                self.currentSortDirection = dir;
                self.GetTreeData();
            }
        });

    }

    private checkVisibleButtons = (selectedNode: INode = null): void => {
        const self = this;
        let nodes: Array<INode> = self.treeView.treeview('getChecked');
        if (selectedNode != null && nodes.length == 0) nodes.push(selectedNode); // Add the selected node to the list if it is not null

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => { self.actionBtns[k].enable = false; });

        // Then switch on the ones we want depending on the nde type
        if (nodes != null) {
            if (nodes.length > 1) {
                self.actionBtns.viewprint.enable = true;
                self.actionBtns.showmap.enable = true;
            }
            else if (nodes.length == 1) {
                self.actionBtns.viewprint.enable = true;
                self.actionBtns.showmap.enable = true;
            }
        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    private updateNumberCheckedMessage = (): void => {
        let num = this.treeView.treeview('getChecked').length;
        let s = num > 1 ? "s" : "";
        if (num == 0) {
            $('#myTasksRecordListNumberCheckedBtn').hide();
        }
        else {
            $('#myTasksRecordListNumberCheckedBtn').html(`${num} item${s} selected`);
            $('#myTasksRecordListNumberCheckedBtn').show();
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    private updatePagingUI = (): void => {
        const self = this;
        if (self.issueCountFromServer_Individual > 0) { $('#myTasksRecordCount').html(' (' + self.issueCountFromServer_Individual + ')'); } else { $('#myTasksRecordCountIndividual').html(); }
        if (self.issueCountFromServer_Group > 0) { $('#myTasksRecordCount').html(' (' + self.issueCountFromServer_Group + ')'); } else { $('#myTasksRecordCountGroup').html(); }
        if (self.issueCountFromServer_Pool > 0) { $('#myTasksRecordCount').html(' (' + self.issueCountFromServer_Pool + ')'); } else { $('#myTasksRecordCountPool').html(); }
        $('#myTasksRecordListShowing').html((self.currentPage + 1).toString());
    }

    private resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.issueCountFromServer_Individual = 0;
        this.issueCountFromServer_Group = 0;
        this.issueCountFromServer_Pool = 0;
        this.currentSortOrder = TaskOrder.CreateDate;
        this.currentSortDirection = OrderDirection.DESC;

        var tree: any = $('#myTasksRecordListTreeResults');
        this.treeData = [];
        this.treeView = tree.treeview();
        this.updatePagingUI();
    }

    private checkFilters = (forceTasks: boolean = false): void => {
        if ($('#myTasksRecordListOptionIndividualTasks').is(':checked') || forceTasks==true) {
            $('#myTasksRecordFilter').find('option').remove().end();
            let filters: Array<IFilterDefinitionModel> = $('#myTasksRecordListContainer [data-mytasksfilters]').data('mytasksfilters');
            filters.forEach(f => {
                $('#myTasksRecordFilter').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
            });
            
            $('#myTasksRecordListIndividualTasksFilter').show();
        }
        else if ($('#myTasksRecordListOptionGroupTasks').is(':checked')) {
            $('#myTasksRecordFilter').find('option').remove().end();
            $('#myTasksRecordFilter').find('option').remove().end();
            let filters: Array<IFilterDefinitionModel> = $('#myTasksRecordListContainer [data-mytaskgroupsfilters]').data('mytaskgroupsfilters');
            filters.forEach(f => {
                $('#myTasksRecordFilter').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
            });

            $('#myTasksRecordListIndividualTasksFilter').show();
        }
        else if ($('#myTasksRecordListOptionPoolTasks').is(':checked')) {
            $('#myTasksRecordFilter').find('option').remove().end();
            $('#myTasksRecordFilter').find('option').remove().end();
            let filters: Array<IFilterDefinitionModel> = $('#myTasksRecordListContainer [data-mytaskpoolsfilters]').data('mytaskpoolsfilters');
            filters.forEach(f => {
                $('#myTasksRecordFilter').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
            });

            $('#myTasksRecordListIndividualTasksFilter').hide();
        }

        function isNumber(value: string | number): boolean {
            return ((value != null) &&
                (value !== '') &&
                !isNaN(Number(value.toString())));
        }
    }

    private getCAMSKeyfromNodes = (): Array<ICAMSKey> => {
        let camsKeys: Array<ICAMSKey> = [];
        let nodes: Array<INode> = this.treeView.treeview('getChecked');
        nodes = nodes.concat(this.treeView.treeview('getSelected'));
        if (nodes && nodes.length) {
            nodes.forEach(n => {
                if (camsKeys.find(c => c.code == n.href) == null) {
                    let camsKey: ICAMSKey = { code: n.href, featureType: n.featureType, wkt: n.wkt, parentCode: n.parentCode, parentFeatureType: n.parentFeatureType };
                    camsKeys.push(camsKey);
                }
            });
        }
        return camsKeys;
    }
}




